import PrimeReact from "primereact/api";

/**
 * The app's z-index scale (cvp-design.md, 2.11 Layout dimensions).
 * Overlay must stay above the fixed top bar and below PrimeReact's toast (1200).
 */
export const zIndexTopBar = 1100;
export const zIndexOverlay = 1150;

/**
 * MultiSelect has no per-component base: its panel reads
 * `PrimeReact.zIndex.overlay` only (multiselect.esm.js:1530), so the layer has
 * to be set once for the whole app.
 *
 * PrimeReactProvider is the non-deprecated route and is deliberately not used
 * here. Its value replaces the whole context, so it would also set
 * `ptOptions.mergeProps` (false today, true under the provider) and freeze
 * `locale` at "en", which `usePrimeLocale` overwrites at runtime.
 */
export function configurePrimeReactZIndex(): void {
  PrimeReact.zIndex.overlay = zIndexOverlay;
  PrimeReact.zIndex.menu = zIndexOverlay;
}
